import type { PrimaryPalette } from '~/domain/shared/branding/models/PrimaryPalette'

export const TrayPrimaryPalette: PrimaryPalette = {
  50: '#e0f5fc',
  100: '#b3e6f7',
  200: '#80d5f1',
  300: '#4dc4ec',
  400: '#26b7e8',
  500: '#00a0dc',
  600: '#0090c6',
  700: '#007dab',
  800: '#006a91',
  900: '#004a66',
  950: '#00354a'
}
